<template>
    <div class="wrap">
        <div >
            <Banner></Banner>
        </div>
        <div class="content">
            <div class="title">
                <span>1、选择视频类别</span>
            </div>
            <div class="type">
                <input class="input-1" type="text" placeholder="点击选择" v-model="type"  @click="dialogShow=true"  readonly unselectable="on" onfocus="this.blur()">
            </div>
            <div class="type" style="margin-top: 10px">
                <input type="text" placeholder="请输入亮点" v-if="this.type=='其他自定义亮点'" v-model="define_type">
            </div>
            <div class="title">
                <span>2、上传心得体会视频</span>
            </div>
            <div class="result" v-if="resultShow==-1">
                <label>视频审核结果：</label>
                <span>{{videoResult}}</span>
                <div>
                    <label>***请点击刷新按钮并重新上传***</label>
                </div>

            </div>
            <div class="video">
                <div class="plus" v-if="!choose">
                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/plus.png" >
                    <input type="file" id="filepicker" accept="video/*" @change="chooseVideoInput"  name="filepicker" ref="file">
                </div>
                <div class="video-wrap"  v-if="choose">
                    <video id="video"  :src="video_url" controls="controls" x5-playsinline="" playsinline="" webkit-playsinline preload="auto" ></video>
                </div>
                <div class="text" >
                    <label v-if="!choose">{{fileName}}</label>
                </div>
                <div>
                    <label class="reload" @click="reload" v-if="choose" ></label>
                </div>
            </div>
            <div class="hint">
                <ol>
                    <li>视频需含医生<font color="red">正脸头像+音频</font>的形式;</li>
                    <li>视频格式为MP4或FLV格式，时长<font color="red">约1-3分钟，200MB以内;</font></li>
                    <li>请务必录制<font color="red">横版、半身视频</font>，建议医生穿白大褂进行录制;</li>
                    <li>视频背景建议用纯色背景;</li>
                    <li>确保上传视频内容无政治等不恰当内容(视频中不得包含药物商品名);</li>
                </ol>
            </div>
            <div class="submit" @click="toSubmit">
                <label>{{submitInfo}}</label>
            </div>
        </div>

        <mt-popup class="popup" v-model="popupVisible" popup-transition="popup-fade" closeOnClickModal="true"
                  position="bottom">
            <mt-picker :slots="slots" @change="slotValueChange" showToolbar>
                <div class="picker-toolbar-title">
                    <div class="usi-btn-cancel" @click="popupVisible = !popupVisible">取消</div>
                    <div class="">请选择</div>
                    <div class="usi-btn-sure" @click="slotValueAdd">确定</div>
                </div>
            </mt-picker>
        </mt-popup>


        <div class="type-selection-wrap" v-if="dialogShow">
<!--            <div class="close" @click="dialogShow=false">-->
<!--                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_close.png">-->
<!--            </div>-->
            <div class="selection">
                <div class="item" v-for="(value,index) in selections" v-bind:key="index" @click="chooseItem(value)">
                    <span>{{value}}</span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {getOssSecret, ksdAddStarVideo, ksdDocGetStar} from "@/assets/js/api";
    import OSS from "ali-oss";
    import {getUuid} from "@/assets/util/util";
    import {Indicator,MessageBox} from "mint-ui";
    import Banner from "@/components/ksd/fragment/Banner";

    export default {
        name: "case",
        components:{
            Banner
        },
        data(){
            return{
                name: '',
                submitInfo:"提交",
                popupVisible: false,
                type:"",
                define_type:"",
                choose:false,
                fileName:"请上传心得体会视频",
                slots: [
                    {
                        values: [],
                    }
                ],
                slotSure:"",
                video_url:"",
                ossKeySecret:'',
                ossPrefix:"ksd/video/",
                file:null,
                docId: this.$store.state.ksd_docId,
                serverVideoUrl:null,
                dialogShow:false,
                selections:["降压疗效","安全性(例如:咳嗽、低血压、水肿、其他)","依从性","药物选择(例如：ARB治疗不达标，自由联合不达标，单药治疗不达标)","其他自定义亮点"],
                resultShow:"",
                videoResult:"",
                exa:this.$route.params.exa
            }
        },
        methods:{
            chooseItem(type){
                this.type = type
                this.dialogShow = false
            },
            slotValueChange(picker, values) {
                this.slotSure = values[0];
            },
            slotValueAdd() {
                this.popupVisible = !this.popupVisible
                this.type = this.slotSure
            },
            slotShow() {
                this.popupVisible = true
                this.slots[0].values = ['降压疗效', '安全性（例如：咳嗽、低血压、水肿、其他）', '依从性','药物选择','其他']
            },
            reload(){
                this.video_url= "";
                this.choose = false;
                this.file = null;
                this.serverVideoUrl = null;
            },
            chooseVideoInput(event) {
                console.log(event)
                this.file = document.getElementById("filepicker").files[0];
                var url = URL.createObjectURL(this.file);
                this.video_url= url;
                this.choose = true
            },
            toSubmit(){
                if(this.type==""){
                    this.$toast("请选择类别")
                    return;
                }
                if(this.type=="其他自定义亮点"&&this.define_type==""){
                    this.$toast("请输入自定义亮点")
                    return;
                }
                if(this.video_url==""){
                    this.$toast("请选择视频")
                    return;
                }
                let _this = this
                Indicator.open({
                    text: '上传中',
                    spinnerType: 'fading-circle'
                });

                if(this.tydocpe=="其他自定义亮点") this.type = this.define_type
                this.ossUpload(_this.file).then(function (res) {
                    console.log(res,'video上传成功！！！')
                    _this.submit(_this.docId,_this.type,res,)
                })

            },
            async submit(docId,videoType,video){
                    let exa = this.exa
                    const res = await ksdAddStarVideo({docId,videoType,video,exa})
                    Indicator.close();
                    if(res.data.success){
                        this.$router.push("docStar")
                    }else{
                        this.$toast(res.data.message)
                }
            },
            async ossUpload(file){

                if(this.serverVideoUrl!=null){
                    return this.serverVideoUrl
                }

                let client = new OSS({
                    region: 'oss-cn-beijing',
                    accessKeyId: 'LTAINtmi5XZ7NaV5',
                    accessKeySecret: this.ossKeySecret,
                    bucket: 'ymd-lcc'
                })

                let uuid = getUuid()

                let suffix = file.name.substring(file.name.lastIndexOf("."))
                // uuid+=("."+file.name.split(".")[1])

                console.log("suffix="+suffix)

                uuid+=suffix
                let key = this.ossPrefix + uuid

                let link=""
                await client.put(key, file).then(function (res) {
                    let str = res.res.requestUrls[0]
                    let status = res.res.status
                    if(status == 200){
                        const workLink =  str.split("?")[0];
                        link = workLink
                    }else {
                        this.$toast("上传失败")
                    }
                    console.log(res)
                }).catch((err) => {
                    console.log(err,"异常啦")
                    Indicator.close();
                    this.fail()
                })

                return link
            },
            async getSecret(){
                const res = await getOssSecret();
                if(res.data.success==true){
                    this.ossKeySecret = res.data.data.accessKeySecret;
                }
            },
            async getStar(docId,exa){
                const res = await ksdDocGetStar({docId,exa})
                console.log(res,"star res")
                if(res.data.data.video!=""){
                    this.resultShow = res.data.data.videoVerify
                    this.videoResult = res.data.data.videoDenyReason
                    this.choose = true
                    this.video_url = res.data.data.video
                    this.serverVideoUrl = res.data.data.video
                    this.type = res.data.data.videoType
                    return
                }
            },
            fail(){
                MessageBox.confirm('',{
                    title:'网络不稳定，视频上传失败',
                    message:'请使用电脑端上传',
                    confirmButtonText:'好的，复制链接',
                    cancelButtonText:'重新上传'
                }).then(action => {
                    if (action == 'confirm') {
                        this.handleCopy("http://app.iumed.com.cn/docLogin")
                    }
                }).catch(error =>{
                    if(error == 'cancel'){
                        console.log('点击取消');
                        window.location.reload()
                    }
                });
            },
            /**
             * 复制方法，来源github
             */
            handleCopy(textString) {
                console.log("开始复制")
                // 数字没有 .length 不能执行selectText 需要转化成字符串
                let input = document.querySelector('#copy-input');
                if (!input) {
                    input = document.createElement('input');
                    input.id = "copy-input";
                    input.readOnly = "readOnly";        // 防止ios聚焦触发键盘事件
                    input.style.position = "absolute";
                    input.style.left = "-representVideoApply";
                    input.style.zIndex = "-1000";
                    document.body.appendChild(input)
                }

                input.value = textString;
                // ios必须先选中文字且不支持 input.select();
                selectText(input, 0, textString.length);
                if (document.execCommand('copy')) {
                    document.execCommand('copy');
                    this.$toast("已复制")
                }else {
                    console.log('不兼容');
                }
                input.blur();

                // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
                // 选择文本。createTextRange(setSelectionRange)是input方法
                function selectText(textbox, startIndex, stopIndex) {
                    if (textbox.createTextRange) {//ie
                        const range = textbox.createTextRange();
                        range.collapse(true);
                        range.moveStart('character', startIndex);//起始光标
                        range.moveEnd('character', stopIndex - startIndex);//结束光标
                        range.select();//不兼容苹果
                    } else {//firefox/chrome
                        textbox.setSelectionRange(startIndex, stopIndex);
                        textbox.focus();
                    }
                }

            },
        },
        mounted(){
            console.log("exa="+this.exa)
            this.getSecret()
            this.getStar(this.docId,this.exa)
        }
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        overflow: scroll;
        font-size: 16px;
    }
    .content{
        flex-grow: 1;
    }
    .head{
        width: 100%;
        position: relative;
    }
    .head .logo{
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        margin: 10px 0;
        .logo_1{
            width: 30px;
            height: 30px;
            margin-left: 20px;
        }
        .logo_2{
            width: 90px;
            height: 30px;
            margin-right: 20px;
        }
    }
    .kv{
        width: 100%;
        height: 180px;
        display: flex;
        justify-content: center;
        img{
            width: 275px;
            height: 157px;
        }
    }
    .content{
        width: 90%;
        margin: 0 auto;
        input{
            width: 100%;
            height: 20px;
            border: #2c9a58 1px solid;
            outline: none;
            text-indent: 5px;
            border-radius: 5px;
            font-size: 15px;
        }
        .input-1{
            background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_triangle.png") no-repeat 98% 50% ;
            background-size: 10px 10px;
        }
        .video{
            width: 100%;
            height: 250px;
            background: #ddd;
            margin: 10px 0;
            display: flex;
            flex-flow: column;
            align-items: center;
            justify-content: center;
            position: relative;

            .reload{
                position: absolute;
                display: block;
                width: 28px;
                height: 28px;
                background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/reload.png") no-repeat;
                background-size: cover;
                bottom: 10px;
                right: 10px;
            }

            .plus{
                margin-top: 15px;
                position: relative;
                width: 60px;
                height: 60px;

                input{
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    opacity: 0;
                }
            }

            img{
                width: 60px;
                height: 60px;
            }
            .text{
                margin-top:20px;
                font-size: 18px;
                color: #bbb;
            }
        }
        .hint{
            text-align: left;
        }
    }
    .content .submit{
        width: 100%;
        margin: 30px auto;
        background: #2c9a58;
        text-align: center;
        border-radius: 5px;
        color: #FFF;
        padding: 5px 0;
        font-size: 15px;
    }
    ol {
       padding-left: 20px;
    }
    ol li{
        margin: 2px 0;
    }
    .popup {
        width: 100%;
    }
    .picker-toolbar-title {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }
    .usi-btn-cancel,
    .usi-btn-sure {
        color: #2c9a58;
    }

    .video-wrap{
        width: 100%;
        height: 150px;
        video{
            width: 100%;
            max-height: 150px;
            /*height: 100%;*/
        }
    }
    .picker-item{
        text-overflow: unset;
        white-space: nowrap;
        font-size: 20px;
    }

    .type-selection-wrap {
        width: 90%;
        /*height: 300px;*/
        background: #FFF;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        height: 260px;
        border-radius: 30px;
        font-weight: bold;

        display: flex;
        align-items: center;
        padding: 10px 0;
        font-size: 14px;

        .close {
            text-align: right;
            margin: 15px 15px 0 0;

            img {
                width: 30px;
                height: 30px;
            }
        }

        .selection{
            display: flex;
            flex-flow: row wrap;
            width: 100%;
            margin: 0 auto;
            justify-content: space-around;
            .item{
                border-radius: 15px;
                width: 30%;
                background: #2c9a58;
                margin: 2px;
                height: 120px;
                color: #FFF;
                text-align: left;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .selection:after{
            width: 30%;
            content: "";
        }
    }


    .title{
        text-align: left;
        margin: 20px 0;
        font-weight: bold;
        color: #FFF;
        span{
            background: #2c9a58;
            padding: 5px 20px;
            border-radius: 5px;
            text-align: left;
        }
    }

    .result{
        font-size: 16px;
        color: #C12935;
        text-align: left;
    }

</style>